import writeDentalPrescription from '@/services/utils/pdf/writeDentalPrescription';
import handleBarcode from "@/services/modules/barcode";
import { useStore } from "vuex";
import useDate from '@/services/utils/day';

const writePrescriptionHelper = () => {
    const { exportToPDF } = writeDentalPrescription();
    const { fetchBarcode } = handleBarcode();
    const store = useStore();
    const { formatDate } = useDate();
    const userName = store.state.user.user.name;
    var qrcode = '';

    const generatePdf = (company, notes, rxList, service, isHideHeader, isHideFooter, salesOrder) => {
        let qrcodeData = JSON.stringify({
            ref_no: service.sale_master ? service.sale_master.bill_number : (service.ipd_register ? service.ipd_register.bill_number : ''),
            ref_date: service.doctor_order.prescription_date ? service.doctor_order.prescription_date : formatDate(new Date, true),
            created_by: userName,
            created_date_time: formatDate(new Date())
        })

        var barCodeQuery = `?code=''&qrcode=${qrcodeData}`;

        const treatments = getTreatment(salesOrder);
        
        Promise.all([
            fetchBarcode(barCodeQuery).then( (res) => {
                qrcode = res.qrcode;
            })
        ]).then(() => {
            exportToPDF(
                company, 
                notes, 
                rxList, 
                service, 
                qrcode, 
                userName, 
                isHideHeader, 
                isHideFooter,
                treatments,
            )
        }).catch((e) => {
            console.log(e);
        })
    }

    const getTreatment = (salesOrder) => {
        if (!salesOrder || !salesOrder.general || salesOrder.general.length < 1) return [];
        
        return salesOrder.general
            .filter((item) => item.dentition_pertains && item.dentition_pertains.length > 0)
            .map((item) => {
                return {
                    name: item.product ? item.product.name : '',
                    tooth: item.dentition_pertains.map((tooth) => tooth.tooth_number).join(', ').toUpperCase(),
                }
            });
    }

    return{
        generatePdf
    }
}

export default writePrescriptionHelper;